const pages = {
  CANCEL_SUBSCRIPTION: {
    title: 'Cancel Subscription - FabFitFun',
    path: '/cancel-subscription',
  },
  CANCEL_SUBSCRIPTION_FINAL: {
    title: 'Cancel Subscription Final - FabFitFun',
    path: '/cancel-subscription-final',
  },
};

export { pages };
